<template>
  <MglMap class="map" v-bind="{ ...$attrs, ...defaults }">
    <slot></slot>
    <MglMarker v-if="$attrs.center" :coordinates="$attrs.center" :color="color"></MglMarker>
  </MglMap>
</template>

<script>
import Mapbox from 'mapbox-gl'
import { MglMap, MglMarker } from 'vue-mapbox'
import { Clone } from '@/utils'
import Colors from '@/styles/base/_color.scss'

const mapDefaults = {
  zoom: 12,
  center: [10.7522, 59.9139],
  accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
  mapStyle: process.env.VUE_APP_MAPBOX_STYLE,
}

export default {
  data() {
    return {
      mapbox: null,
      color: Colors.primary,
      mapDefaults: Clone(mapDefaults),
    }
  },
  computed: {
    defaults() {
      return Object.entries(this.mapDefaults).reduce((res, [key, value]) => {
        res[key] = this.$attrs[key] || value
        return res
      }, {})
    },
  },
  created() {
    this.mapbox = Mapbox
  },
  components: {
    MglMap,
    MglMarker,
  },
}
</script>

<style lang="scss">
.map {
  background-color: css-lighten('border-color', 7%);
}
</style>
